import React from "react";

type Props = {
  condition: boolean;
  wrapper(children: React.ReactElement): React.ReactElement;
};

export const ConditionalWrapper: React.FC<Props> = ({ condition, wrapper, children }) => {
  /**
   * Wrap `children` in a fragment so that the typechecker does not complain about forwarding them.
   */
  const fragment = <>{children}</>;

  if (condition) {
    return wrapper(fragment);
  }
  return fragment;
};
